import * as Sentry from '@sentry/react'
import { toast } from 'react-toastify'

/**
 * Reports an error to both the user (via toast) and Sentry.
 * Use this in catch blocks where an API call or async operation fails.
 *
 * @param {Error} error - The caught error object
 * @param {string} userMessage - Message shown to the user via toast
 * @param {object} context - Extra context sent to Sentry (e.g. { flow: 'checkout' })
 */
export const reportError = (error, userMessage, context = {}) => {
  toast.error(userMessage || 'Something went wrong. Please try again.')
  Sentry.captureException(error, { extra: context })
}

/**
 * Captures an error to Sentry without showing a toast.
 * Use when the user already sees feedback (inline error, redirect, etc.)
 * but you still want visibility in Sentry.
 *
 * @param {Error} error - The caught error object
 * @param {object} context - Extra context sent to Sentry
 */
export const captureError = (error, context = {}) => {
  Sentry.captureException(error, { extra: context })
}
